import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink';
import React from 'react'
import { LotCategoryActionButton } from '../../../lots/components/buttons/SaleLotButtons';
import LotCategoryDialog from '../../dialogs/LotCategoryDialog';
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { LotDataGetLotCategoriesQuery } from '@sales/data/lots/categories/LotCategoryQueries';

const LotCategoryGrid = () => {
    const gridQuery = useAgTechQuery({
        query: LotDataGetLotCategoriesQuery,
        projection: (lotCategoryIndex) => {
            return {
                items: Object.values(lotCategoryIndex)
            }
        }
    });

    return (
        <AgTechGrid
            data={{
                itemQuery: gridQuery
            }}
            header={{
                title: `Lot Categories`,
                content: () => <div id='settings-lot-category-create'><LotCategoryDialog.Button /></div>
            }}
            columns={[
                {
                    header: "Name",
                    value: item => (
                        <AgTechGridLink
                            content={item.name}
                            onClick={e => e.dialogs.openDialog({
                                dialog: () => <LotCategoryDialog lotCategoryId={item.id} />
                            })}
                        />
                    ),
                    classes: 'bg-slate-100 emphasized'
                },
                {
                    header: "Description",
                    value: i => i.description, 
                    size: 2
                },
                {
                    header: "Color",
                    contentClasses: 'px-4 py-2',
                    value: i => (
                        <div className='stretched rounded bordered container'
                            style={{ backgroundColor: i.color }}
                        />
                    )
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return prev.name === curr.name &&
                    prev.description === curr.description &&
                    prev.color === curr.color;
            }}
            searchConfig={{
                options: [
                    { field: 'Name', value: i => i.name },
                    { field: 'Description', value: i => i.description }
                ],
                placeholder: 'Search categories...'
            }}
            noRecordsConfig={{
                message: 'No lot categories were found in the system',
                action: {
                    prompt: 'To create one, click the button below',
                    button: () => <LotCategoryDialog.Button classes='button-highlight' />
                }
            }}
            actions={{
                rendering: i => <LotCategoryActionButton lotCategory={i} />
            }}
        />
    )
}

export default LotCategoryGrid